import { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';
import Loader from 'router/Loader';

const StatisticsPage = Loader(
  lazy(() => import('content/pages/Private/Statistics')),
);

const statisticsRouter: RouteObject[] = [
  {
    path: 'statistics',
    element: <Outlet />,
    children: [
      {
        path: '',
        element: <StatisticsPage />,
      },
    ],
  },
];

export default statisticsRouter;
